import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "question" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "answers" }
const _hoisted_4 = ["type", "name", "id", "value"]
const _hoisted_5 = ["for"]

import { ref, PropType } from "vue";
  import { Question } from "../models/Question";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Question',
  props: {
    question: {
      type: Object as PropType<Question>,
      required: true,
    },
  },
  emits: ["selectedAnswers"],
  setup(__props, { emit: __emit }) {

  

  const emit = __emit;

  const selectedAnswers = ref<number[]>([]);

  function isChecked(answerId: number) {
    emit("selectedAnswers", selectedAnswers.value);

    if (__props.question.questionType === 'Radio group') {
      return selectedAnswers.value[0] === answerId;
    } else {
      return selectedAnswers.value.filter((a) => a === answerId).length > 0;
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.question.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["answer-wrapper", { twoColumns: __props.question.answers.length > 6 }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.answers, (answer) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["answer", {
            radio: __props.question.questionType === 'Radio group',
            checkbox: __props.question.questionType === 'Checkbox group',
            checked: isChecked(answer.id), 
          }]),
            key: answer.id
          }, [
            _withDirectives(_createElementVNode("input", {
              type: __props.question.questionType === 'Radio group' ? 'radio' : 'checkbox',
              name: __props.question.id,
              id: answer.id,
              value: answer.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAnswers).value = $event))
            }, null, 8, _hoisted_4), [
              [_vModelDynamic, selectedAnswers.value]
            ]),
            _createElementVNode("label", {
              for: answer.id
            }, _toDisplayString(answer.title), 9, _hoisted_5)
          ], 2))
        }), 128))
      ], 2)
    ])
  ]))
}
}

})